import { getWidgetByVar } from "./Util.ts";

/**
 * Shows the panel o a select checkbox menu if not visible currently, or hides it if it is visible.
 * @param widgetVar The widget variable of the widget, e.g. "mySelectCheckboxMenu".
 */
export function toggleSelectCheckboxMenu(widgetVar: string): void {
  const widget = getWidgetByVar(widgetVar, PrimeFaces.widget.SelectCheckboxMenu);
  if (widget !== undefined) {
    if (widget.panel.is(":visible")) {
      widget.hide();
    } else {
      widget.show();
    }
  } else {
    console.warn(`Cannot toggle select checkbox menu, widget with widgetVar '${widgetVar}' not found.`);
  }
}
